export const MOUSE_LEFT = 1
export const MOUSE_MIDDLE = 2
export const MOUSE_RIGHT = 3
